var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "600" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "cabecera" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v("edit")]),
                  _vm._v(" Reprogramación de vacaciones")
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c("p", { staticClass: "texto" }, [
                        _c("strong", { staticClass: "texto" }, [
                          _vm._v("Fecha desde: ")
                        ]),
                        _vm._v(_vm._s(this.form.fecha_desde) + "\n            ")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "texto" }, [
                        _c("strong", { staticClass: "texto" }, [
                          _vm._v("Fecha hasta: ")
                        ]),
                        _vm._v(_vm._s(this.form.fecha_hasta) + "\n            ")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "texto" }, [
                        _c("strong", { staticClass: "texto" }, [
                          _vm._v("Días para reprogramar: ")
                        ]),
                        _vm._v(_vm._s(this.form.total_dias) + "\n            ")
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "subtitulo" }, [
                        _c("strong", [_vm._v("fecha de reprogramación: ")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.motivos_reprogramacion,
                                  "item-value": "valor",
                                  "item-text": "valor",
                                  label: "Motivo de la reprogramación",
                                  maxlength: "150",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.motivo_reprogramacion,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "motivo_reprogramacion",
                                      $$v
                                    )
                                  },
                                  expression: "form.motivo_reprogramacion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _vm.form.motivo_reprogramacion == "Otros"
                                ? _c("v-textarea", {
                                    staticClass: "v_card",
                                    attrs: {
                                      rows: "1",
                                      label:
                                        "Justificación de la reprogramación",
                                      "background-color": "amber lighten-4",
                                      rules: _vm.$validate(["required"]),
                                      required: ""
                                    },
                                    model: {
                                      value:
                                        _vm.form.justificacion_reprogramacion,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "justificacion_reprogramacion",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "form.justificacion_reprogramacion"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-layout", { attrs: { wrap: "" } }, [
                        _c("p", [
                          _c("strong", [
                            _vm._v("Ingrese la fecha de su reprogramación: ")
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha inicio",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.calculaDiferenciaDias()
                                  },
                                  change: function($event) {
                                    return _vm.calculaDiasHabiles()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_desde_rep,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_desde_rep", $$v)
                                  },
                                  expression: "form.fecha_desde_rep"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "date",
                                  label: "Fecha fin",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                on: {
                                  input: function($event) {
                                    return _vm.calculaDiferenciaDias()
                                  },
                                  change: function($event) {
                                    return _vm.calculaDiasHabiles()
                                  }
                                },
                                model: {
                                  value: _vm.form.fecha_hasta_rep,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "fecha_hasta_rep", $$v)
                                  },
                                  expression: "form.fecha_hasta_rep"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md4: "" } },
                            [
                              _vm.form.fecha_desde_rep &&
                              _vm.form.fecha_hasta_rep
                                ? _c("v-text-field", {
                                    attrs: { label: "Días", disabled: "" },
                                    model: {
                                      value: _vm.total_dias,
                                      callback: function($$v) {
                                        _vm.total_dias = $$v
                                      },
                                      expression: "total_dias"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n          "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "rgba(14, 187, 178, 0.35)",
                        type: "submit",
                        loading: _vm.loading
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v("REPROGRAMAR\n          ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e137b9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e137b9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_reprogramacion/dialogs/ReprogramarCronograma.vue
// module id = null
// module chunks = 